import "./Report.css";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import Button from 'react-bootstrap/Button';
import { Col, Container, Row } from "react-bootstrap";
import SideNav from "../SideNav/SideNav";

const ReportDynamic = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const [experiment, setExperiment] = useState({});

  useEffect(() => {
    axios.get(`${config.apiUrl}/api/experiment/${id}`)
      .then((response) => {
        setExperiment(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        // Handle error
      });
  }, [id]);


  const co2_comparison = `${config.apiUrl}/api/report/images/co2-comparison/${id}`;

  const goToBasicContext = () => {
    setTimeout(() => {
      navigate(`/pavement-context-basic/${id}`);
    }, 100);
  }

  const goToDetailedContext = () => {
    setTimeout(() => {
      navigate(`/pavement-context-custom/${id}`);
    }, 100);
  }

  const goToPedegreeMatrix = () => {
    setTimeout(() => {
      navigate(`/pedegree-matrix/${id}?backref=pavement-design`);
    }, 100);
  }

  const goToConcreteEmbodiedEmission = () => {
    setTimeout(() => {
      navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
    }, 100);
  }

  const goToAsphaltEmbodiedEmission = () => {
    setTimeout(() => {
      navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
    }, 100);
  }

  const goToPavementDesign = () => {
    setTimeout(() => {
      navigate(`/pavement-design/${id}?backref=result`);
    }, 100);
  }


  return (
    <>
      <SideNav id={id} passed={["pavement-context-basic", "pavement-context-custom", "pedegree-matrix", "pavement-design", "concrete-embodied-emission", "asphalt-embodied-emission"]}
        goToBasicContext={goToBasicContext}
        goToDetailedContext={goToDetailedContext}
        goToAsphaltEmbodiedEmission={goToAsphaltEmbodiedEmission}
        goToConcreteEmbodiedEmission={goToConcreteEmbodiedEmission}
        goToPedegreeMatrix={goToPedegreeMatrix}
        goToPavementDesign={goToPavementDesign}
        goToResults={() => {}}
      />
      <Container>
      <Row>
        <Col>
          <div className="pcb__sub">
            <h3 className="pcb__sub-title">Experiment Context</h3>
            <div className="rep__box">
              <table className="rep__table">
                <thead>
                  <tr>
                    <td class="rep__lable">Experiment</td>
                    <td class="rep__lable">State</td>
                    <td class="rep__lable">Specification</td>
                    <td class="rep__lable">Design Life</td>
                    <td class="rep__lable">Iterations</td>
                    <td class="rep__lable">Analysis Period</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="rep__value">{experiment.title}</td>
                    <td class="rep__value">{experiment?.context?.state}</td>
                    <td class="rep__value">{experiment?.design_specification}</td>
                    <td class="rep__value">{experiment?.design_life}</td>
                    <td class="rep__value">{experiment?.number_of_iterations}</td>
                    <td class="rep__value">{experiment?.analysisPeriod}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="pcb__sub">
            <h3 className="pcb__sub-title">{experiment?.design1?.title}</h3>
            <div className="rep__box">
              <table className="rep__table">
                <tbody>
                  <tr>
                    <td class="rep__lable">Surface</td>
                    <td class="rep__value">{experiment?.design1?.surface?.type}</td>
                    <td class="rep__lable">Min thickness</td>
                    <td class="rep__value">{experiment?.design1?.surface?.thickness?.min}</td>
                    <td class="rep__lable">Max thickness</td>
                    <td class="rep__value">{experiment?.design1?.surface?.thickness?.max}</td>
                  </tr>
                  <tr>
                    <td class="rep__lable">Base</td>
                    <td class="rep__value">{experiment?.design1?.base?.type}</td>
                    <td class="rep__lable">Min thickness</td>
                    <td class="rep__value">{experiment?.design1?.base?.thickness?.min}</td>
                    <td class="rep__lable">Max thickness</td>
                    <td class="rep__value">{experiment?.design1?.base?.thickness?.max}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td class="rep__lable">K value min</td>
                    <td class="rep__value">{experiment?.design1?.kValue?.min.toFixed(2)}</td>
                    <td class="rep__lable">K-Value max</td>
                    <td class="rep__value">{experiment?.design1?.kValue?.max.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
        <Col>
          <div className="pcb__sub">
            <h3 className="pcb__sub-title">{experiment?.design2?.title}</h3>
            <div className="rep__box">
              <table className="rep__table">
                <tbody>
                  <tr>
                    <td class="rep__lable">Surface</td>
                    <td class="rep__value">{experiment?.design2?.surface?.type}</td>
                    <td class="rep__lable">Min thickness</td>
                    <td class="rep__value">{experiment?.design2?.surface?.thickness?.min}</td>
                    <td class="rep__lable">Max thickness</td>
                    <td class="rep__value">{experiment?.design2?.surface?.thickness?.max}</td>
                  </tr>
                  <tr>
                    <td class="rep__lable">Base</td>
                    <td class="rep__value">{experiment?.design2?.base?.type}</td>
                    <td class="rep__lable">Min thickness</td>
                    <td class="rep__value">{experiment?.design2?.base?.thickness?.min}</td>
                    <td class="rep__lable">Max thickness</td>
                    <td class="rep__value">{experiment?.design2?.base?.thickness?.max}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td class="rep__lable">K value min</td>
                    <td class="rep__value">{experiment?.design2?.kValue?.min.toFixed(2)}</td>
                    <td class="rep__lable">K-Value max</td>
                    <td class="rep__value">{experiment?.design2?.kValue?.max.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            
            
          </div>
        </Col>
        <Col>
          <div>
            <img className="rep__diagram" src={co2_comparison} alt="CO2 Comparison" />
          </div>
        </Col>
        <Col>
          <div className="info__panel">
            <ul>
              <h5>Information</h5>
              <li><Link className="sitelinks__link" to="/info/albedo">Albedo</Link></li>
              <li><Link className="sitelinks__link" to="/info/carbon-uptake">Carbon Uptake</Link></li>
              <li><Link className="sitelinks__link" to="/info/end-of-life">End of Life</Link></li>
              <li><Link className="sitelinks__link" to="/info/initial-emission">Initial Emission</Link></li>
              <li><Link className="sitelinks__link" to="/info/mnr">M&R</Link></li>
              <li><Link className="sitelinks__link" to="/info/pvi-deflection">PVI Deflection</Link></li>
              <li><Link className="sitelinks__link" to="/info/pvi-roughness">PVI Roughness</Link></li>
            </ul>
          </div>
        </Col>
      </Row>
      <Row>
        <div className="pcb__box-footer">
          <Button variant="primary" href={`/detailed-report-dynamic/${id}`}>Detailed Report</Button>
        </div>
      </Row>
    </Container>
    </>
  );
};

export default ReportDynamic;